import React from 'react';
import ThemeContext from './ThemeContext';
export default function useTheme() {
  return React.useContext(ThemeContext);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
// module id = 433
// module chunks = 0